import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { changeHandler, editPhone, setPhone, onCheck, onUncheck, termsMsg, clearValid, reportAnalytics } from './AlmostDoneSlice';
import { setIsReceivingAd } from '../saleBlockSlice';
import { connect } from 'react-redux';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import TextInput from '../../../Shared/TextInput/TextInput';
import Config from '../../../../Config';
import TermsOfUsePopup from '../../../Shared/TermsOfUsePopup/TermsOfUsePopup';
import { prepareUrl, buildUrlAndOpenWindow } from '../../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';
import ThirdParty from '../../../Shared/ThirdParty/ThirdParty';

const almostDone = (props) => {
  const [showTermsOfUse, setTermsOfUse] = useState(false);
  const hasPrettyNum = props.saleInfo.productsInfo.selectedProducts?.find((x) => x.isPrettyNum);
  useEffect(() => {
    if (props.saleInfo.flowType == 'existsCustomer') {
      if (props.onSubmit && props.isTermsAccepted == false) {
        props.termsMsg(true);
        props.onValid(false);
      }
      if (props.onSubmit && props.isTermsAccepted) {
        props.termsMsg(false);
        props.clearValid();
        props.onValid(true);
      }
    } else {
      if (props.onSubmit) {
        props.clearValid();
        props.onValid(true);
      }
    }
  }, [props.onSubmit]);

  const closeTermOfUse = () => {
    if (showTermsOfUse) {
      setTermsOfUse(false);
    }
  };

  const showRelevantAddress = (props) => {
    return (
      <div>
        <div>{props.saleInfo.personalInfo.firstName + ' ' + props.saleInfo.personalInfo.lastName}</div>
        {props.saleInfo.setupDeliveries.isNewAddress ? (
          <div>
            {props.saleInfo.setupDeliveries.selectedAddress.streetName +
              ' ' +
              props.saleInfo.setupDeliveries.selectedAddress.home +
              '. ' +
              props.saleInfo.setupDeliveries.selectedAddress.cityName}
          </div>
        ) : (
          <div>
            {props.saleInfo.selectedAddress.streetName +
              ' ' +
              props.saleInfo.selectedAddress.home +
              '. ' +
              props.saleInfo.selectedAddress.cityName}
          </div>
        )}
      </div>
    );
  };

  const phoneComponent = (props) => {
    return (
      <div className='phone-edit'>
        {props.saleInfo.supplyType === 'delivery' ? ' טלפון עבור שליח: ' : 'טלפון עבור הטכנאי: '}
        {props.saleInfo.otpPhone}
        {(props.saleInfo.supplyType === 'technician' && props.saleInfo.saleType === 'internet') ||
          (props.saleInfo.supplyType === 'technician' && props.saleInfo.saleType === 'tv') ? null : (
          <span onClick={() => props.editPhone(props.saleInfo.otpPhone)}>ערוך</span>
        )}
        {props.phoneIsEdit ? (
          <div className='phoneInput'>
            <TextInput
              name='phone'
              type='tel'
              autoComplete='off'
              placeholder='מספר טלפון'
              maxLength='10'
              value={props.form.phone}
              error={props.form.errors.phone}
              onChange={(e) => props.changeHandler({ target: e.target, form: props.form })}
            />
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <Container className='almostDone'>
      <Row>
        <Col>
          <section className='whatWeHave'>
            <p className='whatWeHave__title'>מה היה לנו עד עכשיו?</p>
            <Row className='bill-title'>
              <Col>חיוב חודשי</Col>
            </Row>
            <Row>
              <Col>
                <Row>
                  <Col xs='8' className='product__name'>
                    {props.saleInfo.saleType == 'internet' ? (
                      props.saleInfo.productsInfo.selectedProducts[0].name
                    ) : (
                      <div>{props.saleInfo.offerInfo.basePrice != 0 ? props.saleInfo.offerInfo.title : null} </div>
                    )}
                  </Col>
                  <Col xs='4' className='product__price'>
                    {props.saleInfo.saleType == 'internet' ? (
                      <div> {'₪' + props.saleInfo.productsInfo.selectedProducts[0]?.additionalPrice}</div>
                    ) : (
                      <div>{props.saleInfo.offerInfo.basePrice != 0 ? '₪' + props.saleInfo.offerInfo.basePrice : null} </div>
                    )}
                  </Col>
                </Row>
                {props.saleInfo.saleType === 'tv' || props.saleInfo.saleType === 'cellular' ? (
                  <div>
                    {props.saleInfo.productsInfo.selectedProducts.map(function (item, index) {
                      return (
                        <>
                          <Row className='product' key={index}>
                            <Col xs='4' className='product__name'>
                              <div>{item.name}</div>
                            </Col>
                            <Col xs='4' className='product__phone'>
                              <div>{item.isExistPhone ? item.existPhone : item.newPhone}</div>
                            </Col>
                            <Col xs='4' className='product__price'>
                              <div>{'₪' + item.additionalPrice}</div>
                            </Col>
                          </Row>

                          {item.selectedVasList?.map(function (vas, i) {
                            return (
                              <Row className='product' key={i}>
                                <Col xs='8' className='product__name'>
                                  <div>{vas.title}</div>
                                </Col>
                                <Col xs='4' className='product__price'>
                                  <div>{'₪' + vas.price}</div>
                                </Col>
                              </Row>
                            );
                          })}
                        </>
                      );
                    })}
                  </div>
                ) : null}
                {props.saleInfo.premiumPackages.length > 0 ? (
                  <div>
                    <Row className='bill-title'>
                      <Col>חבילות ערוצים</Col>
                    </Row>
                    <div>
                      {props.saleInfo.premiumPackages.map(function (item, index) {
                        return item.vasList.map(function (pack, index) {
                          if (pack.isSelected) {
                            return (
                              <Row className='product' key={index}>
                                <Col xs='8' className='product__name'>
                                  <div> {pack.title}</div>
                                </Col>
                                <Col xs='4' className='product__price'>
                                  <div> {'₪' + pack.price}</div>
                                </Col>
                              </Row>
                            );
                          }
                        });
                      })}
                    </div>
                  </div>
                ) : null}
                {props.saleInfo.isMeshUpgrade ? (
                  <Row className='product__total'>
                    <Col xs='8' className='product__name'>
                      <div>סופר Wifi</div>
                    </Col>
                    <Col xs='4' className='product__price'>
                      <div>{'₪' + Config.meshUpgradeCost}</div>
                    </Col>
                  </Row>
                ) : null}
                <Row className='product__total'>
                  <Col xs='8' className='product__name'>
                    <div className='monthly-bill-total'>סה"כ חיוב חודשי</div>
                  </Col>
                  <Col xs='4' className='product__price'>
                    <div>{'₪' + props.saleInfo.totalPrice}</div>
                  </Col>
                </Row>

                {props.saleInfo.supplyType === 'delivery' && (
                  <Row className='bill-title'>
                    <Col>חיוב חד פעמי</Col>
                  </Row>
                )}

                {props.saleInfo.supplyType === 'delivery' && (
                  <Row>
                    <Col xs='8' className='product__name'>
                      תשלום עבור שליחות
                    </Col>
                    <Col xs='4' className='product__price'>
                      <div>{'₪' + props.saleInfo.deliveryCost}</div>
                    </Col>
                  </Row>
                )}

                {props.saleInfo.saleType === 'cellular' && (
                  <Row>
                    <Col xs='8' className='product__name'>
                      תשלום חד-פעמי עבור המוצרים
                    </Col>
                    {props.saleInfo.totalPriceOneTime != null || props.saleInfo.totalPriceOneTime != undefined ? (
                      <Col xs='4' className='product__price'>
                        <div>{'₪' + props.saleInfo.totalPriceOneTime}</div>
                      </Col>
                    ) : null}
                  </Row>
                )}

                {(props.saleInfo.supplyType === 'delivery' || hasPrettyNum) && (
                  <Row>
                    <Col className='bill-remark'>* יצורף לחשבונית הקרובה</Col>
                  </Row>
                )}
              </Col>
            </Row>
          </section>
        </Col>
      </Row>
      {props.saleInfo.supplyType != '' && props.saleInfo.supplyType != undefined ? (
        <Row>
          <Col>
            <section className='details'>
              <p className='details__title'>{props.saleInfo.supplyType === 'delivery' ? 'איפה ומתי ניפגש?' : 'פרטי ההתקנה'}</p>
              <div className='details__text'>
                {showRelevantAddress(props)}
                {phoneComponent(props)}
              </div>
              <section className='arrival-time'>
                <p className='details__title'>{props.saleInfo.supplyType === 'delivery' ? `מועד שליח ${window.Config.brand_Name_HE}` : `טכנאי ${window.Config.brand_Name_HE} יגיע ב: `}</p>
                <div className='details__text'>
                  {props.saleInfo.technicianArrivalTime.arrivalTime
                    ? props.saleInfo.technicianArrivalTime.arrivalTime
                    : props.saleInfo.setupDeliveries.deliveryTime}
                </div>
              </section>
            </section>
          </Col>
        </Row>
      ) : null}
      {props.saleInfo.flowType == 'existsCustomer' ? (
        <section className='details'>

          <Row>
            <Col>
              <p className='details__title'>איך משלמים?</p>
              <div className='details__text' style={{ direction: 'rtl' }}>
                החיוב יהיה מאמצעי התשלום שמסתיים ב:
              </div>
              <div className='details__cardnum'>**** **** **** {props.saleInfo.paymentToken?.trim().slice(-4)}</div>
            </Col>
          </Row>

          <Row className='termOfService'>
            <Col xs='12' md='12' className='termOfService__checkbox'>
              <div>
                <CheckBox
                  id='approveTerms'
                  error={props.isTermsMsg ? 'חובה לאשר את תקנון השרות' : ''}
                  onCheck={(e) => props.onCheck()}
                  onUncheck={() => {
                    props.onUncheck();
                  }}>
                  <p className='termOfService__link'>
                    קראתי ואני מסכים <a href='#' onClick={() => setTermsOfUse(true)}>לעיקרי פרטי התכנית</a>, <a href='#' onClick={() => setTermsOfUse(true)}>להסכם ההתקשרות</a> <a href='#' onClick={() => prepareUrl(props.generalTermsAgreementLink, EpiContext)}>ולתנאים הכלליים</a>
                  </p>
                </CheckBox>
              </div>
            </Col>
          </Row>

          {props.showCollaborationApproval && (
            <Row className='isReceivingAd'>
              <Col xs='12' md='12' className='isReceivingAd__checkbox'>
                <div>
                  <CheckBox
                    checked={props.isReceivingAd}
                    label={<ThirdParty />}
                    id='isReceivingAd'
                    onCheck={() => props.setIsReceivingAd(true)}
                    onUncheck={() => props.setIsReceivingAd(false)}
                  />
                </div>
              </Col>
            </Row>
          )}

        </section>
      ) : null}

      {(props.saleInfo.supplyType === 'technician' || props.saleInfo.supplyType === 'delivery') && (
        <Row>
          <Col xs='12' md='12'>
            <p className='adult-note'>חשוב שתהיה מעל גיל 18</p>
          </Col>
        </Row>
      )}

      <TermsOfUsePopup productsInfo={props.saleInfo.productsInfo} showTermsOfUse={showTermsOfUse} closeTermsOfUse={closeTermOfUse} />
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.almostDone.form,
    phoneIsEdit: state.almostDone.phoneIsEdit,
    isTermsMsg: state.almostDone.isTermsMsg,
    isTermsAccepted: state.almostDone.isTermsAccepted,
    productsInfo: state.saleBlock.productsInfo,
    generalTermsAgreementLink: state.saleBlock.epiServer.saleBlock.generalTermsAgreementLink,
    isReceivingAd: state.saleBlock.personalInfo.isReceivingAd,
    showCollaborationApproval: state.saleBlock.checkUser?.showCollaborationApproval,
  };
};

const mapDispatchToProps = { changeHandler, editPhone, setPhone, onCheck, onUncheck, termsMsg, clearValid, reportAnalytics, setIsReceivingAd };

export default connect(mapStateToProps, mapDispatchToProps)(almostDone);
